/**
 * ブラウザバー高さ取得
 */



export function SetValue() {
  function setVh() {
    //MVの高さ
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--svh', `${vh}px`);

  }

  function resizeEnd() {
    let timeoutID = 0;
    let delay = 100;

      window.addEventListener("orientationchange", ()=>{
          clearTimeout(timeoutID);
          timeoutID = setTimeout(()=>{
            setVh();
          }, delay);
      }, false);
  }

  window.addEventListener('DOMContentLoaded', () => {
    setVh();
    resizeEnd();
  })
}



